var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Article = function Article(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.586 3.586A2 2 0 0 1 5 3h10a2 2 0 0 1 2 2h2a2 2 0 0 1 2 2v11a3 3 0 0 1-3 3H7a4 4 0 0 1-4-4V5a2 2 0 0 1 .586-1.414ZM15.172 19H7a2 2 0 0 1-2-2V5h10v13a3 3 0 0 0 .172 1ZM17 7v11a1 1 0 0 0 2 0V7h-2ZM7 8a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Article;